var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 37.5C7.55875 37.5 0 29.4156 0 20C0 10.5844 7.55875 2.5 16.25 2.5C18.3206 2.5 20 4.17938 20 6.25V33.75C20 35.8206 18.3206 37.5 16.25 37.5Z",
    fill: "url(#paint0_linear_1072_433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 16.25C34.1819 16.25 32.5 17.9319 32.5 20C32.5 22.0681 34.1819 23.75 36.25 23.75C38.3181 23.75 40 22.0681 40 20C40 17.9319 38.3181 16.25 36.25 16.25Z",
    fill: "url(#paint1_linear_1072_433)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10C28.3181 10 30 8.31812 30 6.25C30 4.18187 28.3181 2.5 26.25 2.5C24.1819 2.5 22.5 4.18187 22.5 6.25C22.5 8.31812 24.1819 10 26.25 10Z",
    fill: "url(#paint2_linear_1072_433)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 30C24.1819 30 22.5 31.6819 22.5 33.75C22.5 35.8181 24.1819 37.5 26.25 37.5C28.3181 37.5 30 35.8181 30 33.75C30 31.6819 28.3181 30 26.25 30Z",
    fill: "url(#paint3_linear_1072_433)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 15C35.8181 15 37.5 13.3181 37.5 11.25C37.5 9.18187 35.8181 7.5 33.75 7.5C31.6819 7.5 30 9.18187 30 11.25C30 13.3181 31.6819 15 33.75 15Z",
    fill: "url(#paint4_linear_1072_433)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 25C31.6819 25 30 26.6819 30 28.75C30 30.8181 31.6819 32.5 33.75 32.5C35.8181 32.5 37.5 30.8181 37.5 28.75C37.5 26.6819 35.8181 25 33.75 25Z",
    fill: "url(#paint5_linear_1072_433)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7188 18.75H23.75C23.06 18.75 22.5 19.31 22.5 20C22.5 20.69 23.06 21.25 23.75 21.25H32.7188C32.58 20.8581 32.5 20.4388 32.5 20C32.5 19.5612 32.58 19.1419 32.7188 18.75Z",
    fill: "url(#paint6_linear_1072_433)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5535 8.84875L22.6323 10.6906C22.3235 11.3081 22.5735 12.0588 23.1917 12.3681C23.371 12.4581 23.5617 12.5 23.7492 12.5C24.2079 12.5 24.6492 12.2475 24.8685 11.8094L25.7892 9.96875C24.9148 9.86063 24.1348 9.4525 23.5535 8.84875Z",
    fill: "url(#paint7_linear_1072_433)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7897 30.0319L24.8691 28.1913C24.5603 27.5744 23.8116 27.3219 23.1916 27.6319C22.5741 27.9406 22.3234 28.6913 22.6322 29.3094L23.5534 31.1513C24.1353 30.5475 24.9153 30.1394 25.7897 30.0319Z",
    fill: "url(#paint8_linear_1072_433)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0322 11.7112L23.1916 15.1319C22.5741 15.4406 22.3234 16.1912 22.6322 16.8094C22.8516 17.2475 23.2928 17.5 23.7516 17.5C23.9391 17.5 24.1297 17.4581 24.3097 17.3681L31.1516 13.9469C30.5478 13.3656 30.1397 12.5856 30.0322 11.7112Z",
    fill: "url(#paint9_linear_1072_433)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1517 26.0531L24.3098 22.6319C23.691 22.3225 22.941 22.5737 22.6323 23.1912C22.3235 23.8087 22.5735 24.5594 23.1917 24.8687L30.0323 28.2894C30.1398 27.4144 30.5479 26.6344 31.1517 26.0531Z",
    fill: "url(#paint10_linear_1072_433)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 22.5H2.5C1.81 22.5 1.25 21.94 1.25 21.25C1.25 20.56 1.81 20 2.5 20H3.75C4.43937 20 5 19.4394 5 18.75C5 18.06 5.56 17.5 6.25 17.5C6.94 17.5 7.5 18.06 7.5 18.75C7.5 20.8181 5.81812 22.5 3.75 22.5ZM7.13125 15.8813C7.36875 15.65 7.5 15.325 7.5 15C7.5 14.6687 7.36875 14.35 7.13125 14.1125C6.66875 13.65 5.83125 13.65 5.3625 14.1188C5.13125 14.35 5 14.6687 5 15C5 15.325 5.13125 15.65 5.3625 15.8813C5.6 16.1187 5.92438 16.25 6.25 16.25C6.58125 16.25 6.9 16.1187 7.13125 15.8813ZM12.1313 25.8813C12.3687 25.65 12.5 25.325 12.5 25C12.5 24.6688 12.3687 24.35 12.1313 24.1187C11.6687 23.65 10.8313 23.65 10.3625 24.1187C10.1313 24.35 10 24.6688 10 25C10 25.3312 10.1313 25.65 10.3687 25.8875C10.6 26.1187 10.9244 26.25 11.25 26.25C11.5813 26.25 11.9 26.1187 12.1313 25.8813ZM10 12.5C10 11.8106 10.5606 11.25 11.25 11.25C11.94 11.25 12.5 10.69 12.5 10C12.5 9.31 11.94 8.75 11.25 8.75C9.18188 8.75 7.5 10.4319 7.5 12.5C7.5 13.19 8.06 13.75 8.75 13.75C9.44 13.75 10 13.19 10 12.5ZM11.25 28.75C11.25 28.06 10.69 27.5 10 27.5C9.31063 27.5 8.75 26.9394 8.75 26.25C8.75 25.56 8.19 25 7.5 25C6.81 25 6.25 25.56 6.25 26.25C6.25 28.3181 7.93188 30 10 30C10.69 30 11.25 29.44 11.25 28.75ZM17.5 31.25C16.8106 31.25 16.25 30.6894 16.25 30C16.25 29.31 15.69 28.75 15 28.75C14.31 28.75 13.75 29.31 13.75 30C13.75 32.0681 15.4319 33.75 17.5 33.75H20V31.25H17.5ZM15 17.5C14.3106 17.5 13.75 16.9394 13.75 16.25C13.75 15.56 13.19 15 12.5 15C11.81 15 11.25 15.56 11.25 16.25C11.25 18.3181 12.9319 20 15 20H20V17.5H15ZM17.5 7.5C15.4319 7.5 13.75 9.18187 13.75 11.25C13.75 11.94 14.31 12.5 15 12.5C15.69 12.5 16.25 11.94 16.25 11.25C16.25 10.5606 16.8106 10 17.5 10H20V7.5H17.5ZM15 23.75C14.31 23.75 13.75 24.31 13.75 25C13.75 25.69 14.31 26.25 15 26.25H20V23.75H15Z",
    fill: "url(#paint11_linear_1072_433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1072_433",
    x1: 3.2525,
    y1: 30.6844,
    x2: 24.62,
    y2: 9.31687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1072_433",
    x1: 33.5994,
    y1: 22.6506,
    x2: 38.9,
    y2: 17.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1072_433",
    x1: 23.6006,
    y1: 8.90063,
    x2: 28.9012,
    y2: 3.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1072_433",
    x1: 23.6006,
    y1: 36.4006,
    x2: 28.9012,
    y2: 31.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1072_433",
    x1: 31.0994,
    y1: 13.9006,
    x2: 36.4,
    y2: 8.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1072_433",
    x1: 31.1,
    y1: 31.4,
    x2: 36.4006,
    y2: 26.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1072_433",
    x1: 24.9794,
    y1: 22.9969,
    x2: 30.9725,
    y2: 17.0037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1072_433",
    x1: 22.6592,
    y1: 11.9275,
    x2: 25.2035,
    y2: 9.38313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1072_433",
    x1: 22.8391,
    y1: 30.4369,
    x2: 25.0228,
    y2: 28.2538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1072_433",
    x1: 23.6991,
    y1: 17.9675,
    x2: 29.9934,
    y2: 11.6731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1072_433",
    x1: 25.1292,
    y1: 26.8975,
    x2: 28.5629,
    y2: 23.4644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1072_433",
    x1: 7.275,
    y1: 28.825,
    x2: 24.3,
    y2: 11.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.578852b765f1eda98b178641136fed4c.svg";
export { ForwardRef as ReactComponent };